import { fromPairs, IdentifiableMap, RArray, RMutableMap, } from "../../collections";
import { makeImmutable, Quantity } from "../../core";
/**
 * A modifier configuration which can contain multiple ModifierItems from a ModifierType.
 *
 * Can contain duplicates, but they can be constrained by a max value.
 *
 * For example: "ketchup x3, salsa x1, garlic x2"
 */
export class ModifierInstance {
    constructor(params) {
        this.modifierType = params.modifierType;
        this.items = params.items;
        this.freeItems = params.freeItems;
        makeImmutable(this);
    }
    get selectedItems() {
        return this.items.filter((itemInstance) => itemInstance.isSelected).objects;
    }
    eq(other) {
        return (this.typeId.eq(other.typeId) &&
            IdentifiableMap.eq("variantKey", this.items, other.items));
    }
    get typeId() {
        return this.modifierType.id;
    }
    get selectedItemIds() {
        return this.items.objects.flatMap(({ typeId, quantity }) => RArray.repeat(typeId, quantity));
    }
    /** Quantities per typeId, summed across packaging variants */
    get selectedItemQuantities() {
        const map = RMutableMap.empty({
            makeAutoObservable: false,
        });
        for (const item of this.selectedItems) {
            const existing = map.getOrCreate(item.typeId, () => Quantity.Zero);
            map.update(item.typeId, Quantity.fromNumber(existing.value + item.quantity.value));
        }
        return map.entries;
    }
    get storageData() {
        return {
            items: fromPairs(this.items.objects.map((modifierItemInstance) => {
                var _a, _b;
                return [
                    modifierItemInstance.variantKey.value,
                    {
                        quantity: modifierItemInstance.quantity.value,
                        packagingFeeId: (_b = (_a = modifierItemInstance.modifierItemPackagingFeeId) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : undefined,
                    },
                ];
            })),
        };
    }
}
